module.exports = __webpack_public_path__ + "static/ong-den-chuyen-dung-93a64817c63411046de7733fd7c9ed31.jpg";